export enum ContentPosition {
    Left = "left",
    Center = "center",
}

export type HorizontalPos = "left" | "center";

export type VerticalPos = "top" | "middle" | "bottom";
